import catalogueJson from "./experiences.json";
import type { ExperienceCatalogue } from "./types.js";

export const experienceCatalogue: ExperienceCatalogue = catalogueJson;
